import { AccessTokenManagementProvider, Brand, useBrand } from '@hbo/ui-servicing-react-components';
import { gdlv2 } from 'config/gdlv2';
import AppWrapper from 'containers/AppWrapper/AppWrapper';
import { AuthenticationProvider } from 'hooks/useAuth';
import { DataLayerProvider } from 'react-common-gdlv2';

const AuthenticationWrapper = () => {
  const { brand } = useBrand();

  const clientId = {
    [Brand.NatWest]: process.env.REACT_APP_IAM_CLIENT_ID_NATWEST,
    [Brand.RoyalBankOfScotland]: process.env.REACT_APP_IAM_CLIENT_ID_RBS
  }[brand];

  const baseUrl = {
    [Brand.NatWest]: process.env.REACT_APP_IAM_API_BASE_URL_NATWEST,
    [Brand.RoyalBankOfScotland]: process.env.REACT_APP_IAM_API_BASE_URL_RBS
  }[brand];

  return (
    <DataLayerProvider instance={gdlv2}>
      <AccessTokenManagementProvider
        clientId={clientId}
        baseUrl={baseUrl}
        showTimer={!!sessionStorage.getItem('showTimer')}
      >
        <AuthenticationProvider>
          <AppWrapper />
        </AuthenticationProvider>
      </AccessTokenManagementProvider>
    </DataLayerProvider>
  );
};

export default AuthenticationWrapper;
